import { IStore } from "../store";

export const selectSearchState = (store: IStore) => store.contactSearch;
